import { styled } from "styled-components";

export const CloseButton = styled.button`
  width: 36px;
  height: 36px;
  background-color: white;
  font-size: 36px;
  font-weight: 600;

  border: 0px;
  display: flex;
  justify-content: flex-end;
`;
